import { useState, useCallback } from 'react';

export const useDebugLogs = () => {
  const [debugLogs, setDebugLogs] = useState<string[]>([]);

  const addDebugLog = useCallback((message: string) => {
    const timestamp = new Date().toLocaleTimeString();
    const logMessage = `[${timestamp}] ${message}`;
    setDebugLogs((prev) => [...prev.slice(-10), logMessage]); // Keep last 10 logs
    console.log(logMessage); // Still log to console for regular browsers
  }, []);

  const clearDebugLogs = useCallback(() => {
    setDebugLogs([]);
  }, []);

  return {
    debugLogs,
    addDebugLog,
    clearDebugLogs,
  };
};
